"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Sentry = __importStar(require("@sentry/react"));
const axios_1 = require("axios");
const lodash_1 = __importDefault(require("lodash"));
const react_1 = require("react");
const react_router_1 = require("react-router");
if (globalThis.config.IS_SENTRY_ENABLED) {
    Sentry.init({
        dsn: globalThis.config.SENTRY_PUBLIC_DSN,
        release: globalThis.config.VERSION,
        environment: globalThis.config.ENVIROMENT,
        beforeSend(event, hint) {
            const error = hint.originalException;
            if (error instanceof axios_1.AxiosError && error?.status && error.status < 500) {
                return null;
            }
            // remove cookies before sending data to sentry as they are used for authentication
            lodash_1.default.unset(event, 'request.headers.cookie');
            lodash_1.default.unset(event, 'request.cookies');
            // remove the body on rest requests to not leak potentially sensitive data
            lodash_1.default.unset(event, 'request.data');
            event.tags = {
                environment: globalThis.config.ENVIROMENT,
                location: 'frontend',
                requestId: lodash_1.default.get(event, 'request.headers.x-tradeshift-requestid'),
                cardProvider: globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP ? 'AMEX' : 'HSBC',
            };
            return event;
        },
        integrations: [
            // See docs for support of different versions of variation of react router
            // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
            Sentry.reactRouterV6BrowserTracingIntegration({
                useEffect: react_1.useEffect,
                useLocation: react_router_1.useLocation,
                useNavigationType: react_router_1.useNavigationType,
                createRoutesFromChildren: react_router_1.createRoutesFromChildren,
                matchRoutes: react_router_1.matchRoutes,
            }),
            Sentry.replayIntegration(),
        ],
    });
}
